import { render, staticRenderFns } from "./inside-fixedcode.vue?vue&type=template&id=1f65fd46&scoped=true&"
import script from "./inside-fixedcode.vue?vue&type=script&lang=js&"
export * from "./inside-fixedcode.vue?vue&type=script&lang=js&"
import style0 from "./inside-fixedcode.vue?vue&type=style&index=0&id=1f65fd46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65fd46",
  null
  
)

export default component.exports